import { Component, HostBinding, ViewEncapsulation, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { TreoNavigationItem } from 'tsui/@treo';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'sharing-layout',
  templateUrl: './sharing.component.html',
  styleUrls: ['./sharing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SharingLayoutComponent {
  isScreenSmall: boolean;

  @HostBinding('class.fixed-header')
  fixedHeader: boolean;

  @HostBinding('class.fixed-footer')
  fixedFooter: boolean;

  public horizontalNavigation: TreoNavigationItem[];

  private readonly router = inject(Router);

  hideHeader = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects.includes('/shared/fi/')),
    ),
    { initialValue: this.router.url.includes('/shared/fi/') },
  );
}
